import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {


  isAdmin$ = new BehaviorSubject<boolean>(false);
  titleApp$ = new BehaviorSubject<string>('RamDam - Administration')


  constructor() { }

}
